import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Calendar, Users, Loader2 } from "lucide-react";
import { getFechasDisponibles } from "@/api";

export default function Step4Date({ data, update, onNext, onBack, submitting }) {
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setLoading(true);
    getFechasDisponibles(data.tipo_servicio)
      .then((res) => {
        if (active) setDates(res);
      })
      .catch(() => {
        if (active) setError("No se pudieron cargar las fechas disponibles. Inténtalo de nuevo.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [data.tipo_servicio]);

  return (
    <div>
      <h2 className="font-heading font-bold text-2xl text-municipal mb-2">Elige el día de recogida</h2>
      <p className="text-gray-500 mb-8">Estas son las próximas fechas disponibles para tu servicio.</p>

      {loading && (
        <div className="flex items-center justify-center py-16 text-gray-400" data-testid="wizard-dates-loading">
          <Loader2 className="w-6 h-6 animate-spin mr-2" /> Cargando fechas disponibles...
        </div>
      )}

      {!loading && error && <p className="text-sm text-red-500 mb-8">{error}</p>}

      {!loading && !error && (
        <div className="grid sm:grid-cols-2 gap-4 mb-8">
          {dates.map((d) => {
            const selected = data.fecha_preferida === d.fecha;
            return (
              <button
                key={d.fecha}
                type="button"
                onClick={() => update({ fecha_preferida: d.fecha })}
                data-testid={`wizard-date-${d.fecha}`}
                className={`text-left p-5 rounded-xl border-2 transition-all ${
                  selected ? "border-municipal bg-municipal/5" : "border-gray-200 hover:border-municipal/40"
                }`}
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="flex items-center gap-2 font-heading font-semibold text-municipal">
                    <Calendar className="w-4 h-4" /> {d.dia_semana} {d.fecha.split("-").slice(1).reverse().join("/")}
                  </span>
                </div>
                <p className="flex items-center gap-1.5 text-xs text-gray-400">
                  <Users className="w-3.5 h-3.5" /> {d.plazas_libres} plazas disponibles
                </p>
              </button>
            );
          })}
          {dates.length === 0 && (
            <p className="text-sm text-gray-400 col-span-2 text-center py-10">
              No hay plazas disponibles en los próximos días. Contacta con el Ayuntamiento.
            </p>
          )}
        </div>
      )}

      <div className="flex justify-between">
        <Button variant="outline" onClick={onBack} className="border-municipal text-municipal">Atrás</Button>
        <Button
          disabled={!data.fecha_preferida || submitting}
          onClick={onNext}
          className="bg-municipal hover:bg-municipal-dark text-white"
          data-testid="wizard-step4-next"
        >
          {submitting ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
          Continuar
        </Button>
      </div>
    </div>
  );
}

